export default __webpack_public_path__ + "static/media/Audiyoga-layout1.d9bf79ed.wav";